<template>
  <div class="cardBox homePage">
    <head-page @childFun="getUser"></head-page>
    <div class="search">
      <div class="inputBox">
        <span>病理号：</span>
        <input
          type="text"
          v-model="param.tbsNo"
          placeholder="请输入..."
          style="width: 185px"
        />
      </div>
      <div class="selectBox">
        <span>状态：</span>
        <label>
          <input type="text" v-model="setReportTxt" readonly />
          <img src="@/assets/images/down.png" />
          <ul>
            <li
              :class="param.state == '' ? 'active' : ''"
              @click="setReport(-1)"
            >
              全部
            </li>
            <li :class="param.state == 1 ? 'active' : ''" @click="setReport(1)">
              判读中
            </li>
            <li :class="param.state == 2 ? 'active' : ''" @click="setReport(2)">
              已判读
            </li>
            <li :class="param.state == 3 ? 'active' : ''" @click="setReport(3)">
              已复核
            </li>
          </ul>
        </label>
      </div>
      <div class="selectBox">
        <span>阴阳性：</span>
        <label>
          <input type="text" v-model="tbsPvnTxt" value="全部" readonly />
          <img src="@/assets/images/down.png" />
          <ul>
            <li
              :class="param.tbsPvn == '' ? 'active' : ''"
              @click="setTbsPvn(0)"
            >
              全部
            </li>
            <li
              :class="param.tbsPvn == 1 ? 'active' : ''"
              @click="setTbsPvn(1)"
            >
              阴性
            </li>
            <li
              :class="param.tbsPvn == 2 ? 'active' : ''"
              @click="setTbsPvn(2)"
            >
              阳性
            </li>
          </ul>
        </label>
      </div>
      <div class="selectBox">
        <span> </span>
        <!-- <label> <input type="text" class="endtime" autocomplete="off" placeholder="开始日期" readonly="" id="endTime"> <img src="@/assets/images/pan.png"> <input type="text" class="endtime" autocomplete="off" placeholder="结束日期" readonly="" id="endTime"> <img src="@/assets/images/time.png"> </label> -->
        <div class="block">
          <span class="demonstration">扫描时间：</span>
          <el-date-picker
            v-model="timeValue"
            value-format="yyyy-MM-dd"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          >
          </el-date-picker>
        </div>
      </div>
      <div class="searchbox">
        <a class="searchBtn" @click="search">
          <img src="@/assets/images/serch.png" /> <span>查询</span>
        </a>
      </div>
    </div>
    <div class="cardBody">
      <table cellspacing="0" cellpadding="0" border="0">
        <thead>
          <tr>
            <th class="point" width="6%" @click="reSortAttr(0, 0)">序号</th>
            <th class="point" width="6%" @click="reSortAttr(1, 0)">拨片号</th>
            <th class="point" width="6%" @click="reSortAttr(2, 0)">阅片进度</th>
            <th class="point" width="10%" @click="reSortAttr(3, 0)">
              阅片结果
            </th>
            <th class="point" width="10%" @click="reSortAttr(4, 0)">
              扫描时间
            </th>
            <th class="point" width="10%" @click="reSortAttr(5, 0)">
              复合时间
            </th>
            <th class="point" width="10%" @click="reSortAttr(6, 0)">
              阅片报告
            </th>
            <th width="22%">操作</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in list" :key="index">
            <td>
              <p>
                {{ item.itemIndex }}
              </p>
            </td>
            <td>{{ item.tbsNo }}</td>
            <td>
              <template v-if="item.state == 1">判读中 </template>
              <template v-else-if="item.state == 2"> 已判读 </template>
              <template v-else-if="item.state == 3"> 已复核 </template>
            </td>
            <td>
              <template v-if="item.tbsPvn == 1"> 阴性 </template>
              <template v-else-if="item.tbsPvn == 2">
                <font color="#f00"> 阳性</font>
              </template>
              <template v-else> </template>
            </td>
            <td>
              <p>{{ item.createTime }}</p>
            </td>
            <td>
              <p>{{ item.checkTime }}</p>
            </td>
            <td>
              <template v-if="item.hasReport == 0">
                <font color="#f00"> 未生成</font>
              </template>
              <template v-else>
                <font color="#409eff"> 已生成</font>
              </template>
            </td>
            <td>
              <p>
                <a class="btn blur" @click="goDetail(item)">
                  <img src="@/assets/images/img.png" /><span>查看影像</span>
                </a>
                <template v-if="item.hasReport == 0">
                  <a class="btn die">
                    <img src="@/assets/images/baogao2.png" /><span
                      >查看报告</span
                    >
                  </a>
                </template>
                <template v-else>
                  <a class="btn" @click="goReport(item)">
                    <img src="@/assets/images/baogao.png" /><span
                      >查看报告</span
                    >
                  </a>
                </template>

                <template v-if="param.roleId == 1"></template>
                <a class="btn del" @click="del(item)"> <span>删除</span> </a>
              </p>
            </td>
          </tr>
        </tbody>
      </table>
      <div class="pageAcount">
        <a @click="prev"> <img src="@/assets/images/prev.png" /> </a>
        <template v-for="i in pageCount">
          <a :key="i" :class="i == listIndex ? 'on' : ''" @click="goItem(i)">{{
            i
          }}</a>
        </template>
        <a @click="next"> <img src="@/assets/images/next.png" /> </a>
        <span>跳至</span> <input v-model="param.current" /> <span>页</span>
        <a class="sureBtn" @click="getItem">确定</a>
      </div>
    </div>
    <foot-page></foot-page>
  </div>
</template>

<style lang="scss" scoped>
@import "./home.scss";
</style> 

<script>
import headPage from "../../components/Head/head";
import footPage from "../../components/footer/foot";
import preventBack from "vue-prevent-browser-back";
export default {
  mixins: [preventBack],
  data() {
    return {
      setReportTxt: "全部",
      tbsPvnTxt: "全部",
      timeValue: [],
      param: {
        current: 1,
        size: 20,
        beginTime: "",
        endTime: "",
        state: "",
        tbsPvn: "",
        tbsNo: "",
        sortAttr: 0,
        sortType: 0,
      },
      listIndex: 0,
      list: [],
      pageCount: 0,
      sortAttr: 0,
      sortType: 0,
    };
  },
  components: {
    headPage,
    footPage,
  },

  mounted() {},
  methods: {
    reSortAttr(sortNum) {
      let that = this;

      let { sortAttr, sortType } = that.param;

      if (sortNum == 0) {
        that.param.sortAttr = 0;
        that.param.sortType = 0;
        that.getItem();
        return;
      }

      if (sortAttr == sortNum) {
        that.param.sortType = sortType == 2 ? 0 : sortType + 1;
      } else {
        that.param.sortAttr = sortNum;
        that.param.sortType = 0;
      }
      that.getItem();
    },
    getUser(data) {
      let that = this;
      if (data.status == 2) {
        that.$toast.fail({
          type: "fail",
          message: "已停用，请联系管理员",
          duration: 0,
          overlay: true,
          closeOnClickOverlay: true,
          closeOnClick: true,
        });
        return;
      }
      console.log(data);
      that.param.tenantId = data.id;
      that.param.roleId = data.roleId;
      that.getItem();
    },
    setReport(i) {
      let that = this;
      if (i == "-1") {
        that.setReportTxt = "全部";
        that.param.state = "";
        return;
      }
      if (i == 0) {
        that.setReportTxt = "未判断";
        that.param.state = "0";
        return;
      }
      if (i == 1) {
        that.setReportTxt = "判读中";
        that.param.state = i;
        return;
      }
      if (i == 2) {
        that.setReportTxt = "已判读";
        that.param.state = i;
        return;
      }
      if (i == 3) {
        that.setReportTxt = "已复核";
        that.param.state = i;
        return;
      }
    },
    setTbsPvn(i) {
      let that = this;
      if (i == 0) {
        that.tbsPvnTxt = "全部";
        that.param.tbsPvn = i;
        return;
      }
      if (i == 1) {
        that.tbsPvnTxt = "阴性";
        that.param.tbsPvn = i;
        return;
      }
      if (i == 2) {
        that.tbsPvnTxt = "阳性";
        that.param.tbsPvn = i;
        return;
      }
      if (i == 3) {
        that.tbsPvnTxt = "未知";
        that.param.tbsPvn = i;
        return;
      }
    },
    del(obj) {
      let that = this;
      console.log(obj);
      let studyId = obj.id;
      that.$dialog
        .confirm({
          message: "确定要删除这条数据吗?",
        })
        .then(() => {
          that.ajax.post("tbs/delete/" + studyId).then((res) => {
            that.$toast("删除成功");
            that.getItem();
          });
        });
    },
    goDetail(obj) {
      let that = this;
      let studyId = obj.id;
      that.$router.replace({
        name: "Detail",
        query: {
          studyId: studyId,
        },
      });
    },
    goReport(obj) {
      let that = this;
      let studyId = obj.id;
      that.$router.replace({
        name: "Report",
        query: {
          studyId: studyId,
        },
      });
    },
    prev() {
      let that = this;
      let { current } = that.param;
      that.param.current = current <= 1 ? 1 : current - 1;
      that.getItem();
    },
    next() {
      let that = this;
      let { current } = that.param;
      that.param.current = current < that.pageCount ? current + 1 : current;
      that.getItem();
    },
    goItem(i) {
      let that = this;
      that.param.current = i;
      that.getItem();
    },
    getTypeList() {
      let that = this;
      that.ajax.post("tbs/typeList");
    },
    search() {
      let that = this;
      let { timeValue, param } = that;
      param.beginTime = timeValue ? timeValue[0] : "";
      param.endTime = timeValue ? timeValue[1] : "";
      that.getItem();
    },
    getItem() {
      let that = this;
      console.log(that.param);
      that.ajax.post("tbs/selectByPage", that.param).then((res) => {
        res.data.records.map((a, i) => {
          if (that.param.current == 1) {
            a.itemIndex = i + 1;
          } else if (that.param.current > 1) {
            a.itemIndex = (that.param.current - 1) * 10 + i + 1;
          }
        });

        // let item = new Array();
        // console.log(that.param.tenantId);
        // res.data.records.map((a, i) => {
        //   console.log(a.tenantId);
        //   if(a.tenantId==that.param.tenantId){
        //     item=[...item,a]
        //   }
        // });

        that.listIndex = parseInt(res.data.current).toString();
        that.pageCount = Math.ceil(res.data.total / that.param.size);
        that.list = res.data.records;
      });
    },
  },
};
</script>
